import { render, staticRenderFns } from "./multiplechoicesingle.vue?vue&type=template&id=302413a6&scoped=true&"
import script from "./multiplechoicesingle.vue?vue&type=script&lang=js&"
export * from "./multiplechoicesingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302413a6",
  null
  
)

export default component.exports